/**
 * Firebase web initialisation (Cloud Messaging).
 * Config comes from VITE_FIREBASE_* env vars.
 */
import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getMessaging, isSupported, type Messaging } from 'firebase/messaging';

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

/** VAPID key = Firebase console → Cloud Messaging → "Web Push certificate". */
export const FIREBASE_VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY as string | undefined;

let app: FirebaseApp | null = null;
let messagingPromise: Promise<Messaging | null> | null = null;

export const getFirebaseApp = (): FirebaseApp => {
  if (!app) app = initializeApp(firebaseConfig);
  return app;
};

/** Returns a Messaging instance, or null if the browser/config can't support it. */
export const getMessagingIfSupported = (): Promise<Messaging | null> => {
  if (!messagingPromise) {
    messagingPromise = (async () => {
      try {
        if (!firebaseConfig.apiKey || !(await isSupported())) return null;
        return getMessaging(getFirebaseApp());
      } catch {
        return null;
      }
    })();
  }
  return messagingPromise;
};
